import { Route, Routes } from 'react-router-dom';
import WebtoonPage from './WebtoonPage';

export default function WebtoonRouter() {
  return (
    <Routes>
      <Route index element={<WebtoonPage />} />
    </Routes>
  );
}
